import { useEffect } from "react";

export function useBodyClass(className: string, enabled = true) {
	useEffect(() => {
		if (!enabled) return;
		document.body.classList.add(className);
		return () => {
			document.body.classList.remove(className);
		};
	}, [className, enabled]);
}
